import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@mui/material';
import LoadingIndicator from './LoadingIndicator';
import { db } from '../instant';
import { LATEST_VERSION_ID, PROD_DOMAIN, DEV_DOMAIN } from '../constants';
import { useState } from 'react';

const CURRENT_COMMIT = process.env.REACT_APP_GIT_COMMIT;
const NODE_ENV = process.env.NODE_ENV;

// Check if current URL matches dev or prod domain
const isDevOrProdUrl = (): boolean => {
    const hostname = window.location.hostname;
    return hostname === PROD_DOMAIN || hostname === DEV_DOMAIN;
};

export default function NewVersionDialog() {
    const [dismissed, setDismissed] = useState(false);
    const { data, isLoading, error } = db.useQuery({
        latestVersion: {
            $: {
                where: {
                    id: LATEST_VERSION_ID,
                },
            },
        },
    });

    const latestVersion = data?.latestVersion ?? [];
    const latestCommit = latestVersion[0]?.git_commit;
    const isOutdated = latestVersion.length === 1 && CURRENT_COMMIT !== latestCommit;

    // Derive open from data: show dialog when outdated and not dismissed (no setState-in-effect)
    const open = isOutdated && !dismissed;

    // Show version dialog in both prod and dev deployments (both are production builds)
    // Only hide in local development (when running yarn start) or preview deployments
    if (NODE_ENV !== 'production' || !isDevOrProdUrl()) {
        return <></>;
    }

    if (isLoading) {
        return <LoadingIndicator message="Loading version info..." />;
    }

    if (error) {
        return <Typography>Oh no! {JSON.stringify(error)}</Typography>;
    }

    if (latestVersion.length !== 1) {
        return <Typography>error getting latest version info</Typography>;
    }

    const onClose = () => {
        setDismissed(true);
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>An update is available!</DialogTitle>

            <DialogContent>
                <DialogContentText>
                    <>
                        You aren&apos;t using the latest version of the app! You&apos;re using #{CURRENT_COMMIT}, but #{latestCommit} is now
                        available. Try refreshing the page and/or reopening the app to update.
                    </>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button color="error" onClick={onClose}>
                    Dismiss
                </Button>
            </DialogActions>
        </Dialog>
    );
}
